export default "__VITE_ASSET__CsE0E6z$__"